module.exports = __webpack_public_path__ + "marriot-card-bottom-right@2x.2L3-sA3P.png";